enum AllocationStatus {
  Canceled = "CANCELED",
  Executed = "EXECUTED",
  Active = "ACTIVE",
}

export default AllocationStatus;
